import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "grade" }
const _hoisted_2 = { class: "grade__top" }
const _hoisted_3 = { class: "grade__content" }
const _hoisted_4 = { class: "grade__icons" }
const _hoisted_5 = { class: "grade__image" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "grade__softs" }
const _hoisted_8 = { class: "grade__softs-content" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "grade__item-wrap" }
const _hoisted_11 = { class: "grade__item-icon" }
const _hoisted_12 = { class: "grade__item-text" }

import DecorTitle from "@/components/uikit/DecorTitle.vue";
import UserPoints from "@/components/uikit/UserPoints.vue";
import GreenButton from "@/components/uikit/GreenButton.vue";
import InlineSvg from "@/components/uikit/InlineSvg.vue";
import { useRouter } from "vue-router";
import { useGameStore } from "@/stores/index";
import { onMounted, ref } from "vue";
import { getImagePath } from "@/utils/image";

interface Skills {
  id: number;
  name: string;
  icon: string;
}

const maxSelection = 5;

// Переключение активности скиллов

export default /*@__PURE__*/_defineComponent({
  __name: 'GradeScreen',
  setup(__props) {

const store = useGameStore();
const router = useRouter();
const selectedItems = ref<Skills[]>([]);
const toggleSelection = (item: Skills) => {
  const index = selectedItems.value.findIndex(
    (selected) => selected.id === item.id
  );

  if (index !== -1) {
    selectedItems.value.splice(index, 1);
  } else if (selectedItems.value.length < maxSelection) {
    selectedItems.value.push(item);
  }
};

// Выбор скиллов
const selectSkills = async () => {
  if (selectedItems.value.length === 5) {
    const ids = selectedItems.value.map((item) => Number(item.id));
    await store.selectSkills(ids);
    router.push("/processing");
  }
};

onMounted(() => {
  store.getSkills();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "grade__bg" }, [
      _createElementVNode("img", {
        src: "/images/grade-bg.jpg",
        alt: ""
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DecorTitle, {
        title: 'ПРОКАЧАЙ СВОЕГО ПЕРСОНАЖА',
        icon: '/images/grade-icon-top.svg'
      }),
      _createVNode(UserPoints, {
        count1: _unref(store).playerScore
      }, null, 8, ["count1"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedItems.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "grade__icon grade__icon--active"
          }, [
            _createVNode(InlineSvg, {
              src: '/images/' + item.icon + '.svg',
              class: "icon"
            }, null, 8, ["src"])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5 - selectedItems.value.length, (i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: 'empty-' + i,
            class: "grade__icon"
          }))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: 
            _unref(getImagePath)(_unref(store).playerInfoArray?.selectedCharacter?.imagePath)
          ,
          alt: ""
        }, null, 8, _hoisted_6),
        (selectedItems.value.length === 5)
          ? (_openBlock(), _createBlock(GreenButton, {
              key: 0,
              onClick: selectSkills
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("Завершить")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "grade__softs-top" }, [
          _createElementVNode("div", { class: "grade__softs-top-wrap" }, "Софты")
        ], -1)),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).skillsList, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["grade__item", {
              'grade__item--active': selectedItems.value.some(
                (selected) => selected.id === item.id
              ),
            }]),
              key: i,
              onClick: ($event: any) => (toggleSelection(item))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(InlineSvg, {
                    src: '/images/' + item.icon + '.svg',
                    class: "my-custom-icon"
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1)
              ])
            ], 10, _hoisted_9))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})